import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    subject: '',
  },
  lessonPlanBackUrl: null,
}

export const lessonPlansUI = createSlice({
  name: 'lessonPlansUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setLessonPlanBackUrl: (state, { payload }) => {
      state.lessonPlanBackUrl = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setSubject,
  setLessonPlanBackUrl,
  trackActiveFilters,
  clearAllFilters,
} = lessonPlansUI.actions

export default lessonPlansUI.reducer
